// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"690509cc","458":"52d13258","631":"23d76a70","774":"ae60b8ec","787":"98de6c0e","858":"2ce77b76"}[chunkId] + ".chunk.js";
};